import { Card, EmptyState, ErrorState, LoadingState } from '@/ui'
import { formatDateTime } from '@/lib/format'
import { useOrderHistory } from '../queries'

export function HistoryTab({ orderId }: { orderId: string }) {
  const { data, isLoading, isError, error, refetch } = useOrderHistory(orderId)

  if (isLoading) return <LoadingState />
  if (isError) return <ErrorState error={error} onRetry={() => void refetch()} />
  if (!data || data.items.length === 0) {
    return <EmptyState title="История пуста" />
  }

  // Newest first for display.
  const entries = [...data.items].reverse()

  return (
    <Card>
      <ul className="divide-y divide-black/5">
        {entries.map((e, i) => (
          <li key={i} className="px-4 py-3">
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm font-medium text-tg-text">{e.type || '—'}</span>
              <span className="text-xs text-tg-hint">{formatDateTime(e.created_at)}</span>
            </div>
            {(e.old_status || e.new_status) && (
              <div className="mt-0.5 text-xs text-tg-hint">
                {e.old_status || '—'} → {e.new_status || '—'}
                <span className="ml-2 rounded bg-tg-secondary-bg px-1.5 py-0.5">{e.source}</span>
              </div>
            )}
            {e.comment && <div className="mt-1 text-sm text-tg-text">{e.comment}</div>}
          </li>
        ))}
      </ul>
    </Card>
  )
}
